export const DRAWER_CONTEXT_WORKSPACE = 'workspace'
export const DRAWER_CONTEXT_ACCOUNT = 'account'
export const DRAWER_CONTEXT_REACHOUT = 'reachout'
export const DRAWER_CONTEXT_SALES_PLAY_MEMBER = 'sales_play_member'
export const DRAWER_CONTEXT_CONTACT = 'contact'

export type DrawerContextType =
  | typeof DRAWER_CONTEXT_WORKSPACE
  | typeof DRAWER_CONTEXT_ACCOUNT
  | typeof DRAWER_CONTEXT_REACHOUT
  | typeof DRAWER_CONTEXT_SALES_PLAY_MEMBER
  | typeof DRAWER_CONTEXT_CONTACT

export type DrawerContext =
  | { type: typeof DRAWER_CONTEXT_WORKSPACE }
  | {
      type: typeof DRAWER_CONTEXT_ACCOUNT
      accountId: string
    }
  | {
      type: typeof DRAWER_CONTEXT_REACHOUT
      reachoutId: string
      accountId?: string
      contactId?: string
      agentRunId?: string
    }
  | {
      type: typeof DRAWER_CONTEXT_SALES_PLAY_MEMBER
      playId: string
      membershipId: string
      kind: 'account' | 'contact'
      accountId?: string
      contactId?: string
    }
  | {
      type: typeof DRAWER_CONTEXT_CONTACT
      contactId: string
      accountId: string
    }

export function isDrawerContext(value: unknown): value is DrawerContext {
  if (!value || typeof value !== 'object') return false
  const candidate = value as Partial<DrawerContext>
  if (candidate.type === DRAWER_CONTEXT_WORKSPACE) return true
  if (candidate.type === DRAWER_CONTEXT_ACCOUNT) {
    return Boolean(String(candidate.accountId || '').trim())
  }
  if (candidate.type === DRAWER_CONTEXT_REACHOUT) {
    return Boolean(String(candidate.reachoutId || '').trim())
  }
  if (candidate.type === DRAWER_CONTEXT_SALES_PLAY_MEMBER) {
    return Boolean(String(candidate.membershipId || '').trim())
  }
  if (candidate.type === DRAWER_CONTEXT_CONTACT) {
    return Boolean(String(candidate.contactId || '').trim())
  }
  return false
}

/** Derive a page context hint from a DrawerContext for passing to the workspace chat. */
export function pageContextFromDrawer(ctx: DrawerContext | null | undefined): Record<string, string> | null {
  if (!ctx) return null
  if (ctx.type === DRAWER_CONTEXT_ACCOUNT) {
    return { page_type: 'account', subject_id: ctx.accountId }
  }
  if (ctx.type === DRAWER_CONTEXT_REACHOUT) {
    return {
      page_type: 'reachout',
      subject_id: ctx.reachoutId,
      ...(ctx.accountId ? { account_id: ctx.accountId } : {}),
    }
  }
  if (ctx.type === DRAWER_CONTEXT_SALES_PLAY_MEMBER) {
    return {
      page_type: 'sales_play_member',
      subject_id: ctx.membershipId,
      sales_play_id: ctx.playId,
      ...(ctx.accountId ? { account_id: ctx.accountId } : {}),
      ...(ctx.contactId ? { contact_id: ctx.contactId } : {}),
    }
  }
  if (ctx.type === DRAWER_CONTEXT_CONTACT) {
    return {
      page_type: 'contact',
      subject_id: ctx.contactId,
      account_id: ctx.accountId,
    }
  }
  return null
}
